import { render, staticRenderFns } from "./VueSlickCarousel.vue?vue&type=template&id=21e5e2d0&scoped=true&lang=pug&"
import script from "./VueSlickCarousel.vue?vue&type=script&lang=js&"
export * from "./VueSlickCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VueSlickCarousel.vue?vue&type=style&index=0&id=21e5e2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e5e2d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e5e2d0')) {
      api.createRecord('21e5e2d0', component.options)
    } else {
      api.reload('21e5e2d0', component.options)
    }
    module.hot.accept("./VueSlickCarousel.vue?vue&type=template&id=21e5e2d0&scoped=true&lang=pug&", function () {
      api.rerender('21e5e2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autoservice/components/VueSlickCarousel.vue"
export default component.exports